// For bill history and payment info routes
import layouts from '../../layout';
import BillingsTable from '../../views/pages/billing/view';
import PaymentMethods from '../../views/pages/payment-methods/view';
import ExtensionPage from '../../views/pages/extension-counts/view';

export default [
    {
        path: '/bill-history',
        name: 'bill-history',
        component: BillingsTable,
        meta: {
          auth: true,
          layout: layouts.navLeft,
          searchable: true,
          tags: ['bill-history'],
          roles: [1, 3, 11, 12]
        }
    },
    {
      path: '/payment-info',
      name: 'payment-info',
      component: PaymentMethods,
      meta: {
        auth: true,
        layout: layouts.navLeft,
        searchable: true,
        tags: ['payment-info'],
        roles: [1, 3, 11, 12]
      }
    },
    {
      path: '/extension-counts',
      name: 'extension-counts',
      component: ExtensionPage,
      meta: {
        auth: true,
        layout: layouts.navLeft,
        searchable: true,
        tags: ['extension-counts'],
        roles: [1, 3, 11, 12]
      }
    }
];
